import React, { useState, useEffect } from "react";
import axios from "axios";
import "./ktnlcustomersupport.css";
import CONFIG from "./config";
const Ktnlcustomersupport = () => {
  const [data, setData] = useState([]);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${CONFIG.BASE_URL}/KTNLSupport/Customersupport`
        );
        console.log("Fetched data:", response.data);
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        alert("Failed to fetch data. Please try again.");
      }
    };
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title || !description) {
      alert("Both Title and Description are required.");
      return;
    }

    try {
      const payload = {
        Title: title,
        Customersupprtcontent: description,
      };
      const response = await axios.post(
        `${CONFIG.BASE_URL}/KTNLSupport/Customersupport`,
        payload
      );
      setData([...data, response.data]);
      setTitle("");
      setDescription("");
    } catch (error) {
      if (error.response && error.response.data.message) {
        alert(error.response.data.message);
      } else {
        console.error("Error posting data:", error);
        alert("An unexpected error occurred. Please try again.");
      }
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(
        `${CONFIG.BASE_URL}/KTNLSupport/Customersupport/${id}`
      );
      setData(data.filter((item) => item.id !== id));
    } catch (error) {
      console.error("Error deleting data:", error);
      alert("Failed to delete the record. Please try again.");
    }
  };

  return (
    <div className="ktnl_custsupport  wow fadeInUp" data-wow-delay="0.2s">
      <h1
        className="table-title"
        style={{
          fontSize: "24px",
          fontFamily: "Poppins, sans-serif",
          color: "Navy",
          fontWeight: "600",
          textTransform: "uppercase",
          letterSpacing: "1px",
          textAlign: "center",
          paddingBottom: "5px",
          marginTop: "12px",
          alignItems: "center",
        }}
      >
        KTNL Customer Support{" "}
      </h1>

      <form onSubmit={handleSubmit}>
        <div className="col-md-6 d-flex mt-3 m-0">
          <label>Title</label> <span>:</span>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>
        <div className="col-md-6 d-flex mt-3">
          <label>Description:</label> <span>:</span>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          ></textarea>
        </div>
        <div className="col-md-6 d-flex mt-3">
          {" "}
          <button className="btnblue" type="submit">
            Submit
          </button>
        </div>
      </form>
      <h2>Records</h2>
      <table border="1">
        <thead>
          <tr>
            <th>Title</th>
            <th>Description</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((item) => (
              <tr key={item.id}>
                <td>{item.title}</td>
                <td>{item.description}</td>
                <td>
                  <button onClick={() => handleDelete(item.id)}>
                    <i className="fa fa-trash" style={{ color: "white" }}></i>{" "}
                    {}
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Ktnlcustomersupport;
